import React from 'react';
import BoschIcon from '@boschebike/ebds-react/dist-esm/components/BoschIcon.js';
import { useIconChunk as useEBDSIconChunk, IconAsChunk as EBDSIconAsChunk } from '@boschebike/ebds-react-icons';

/**
 * @deprecated Please move to direct import from ebds-react/dist/ssr
 */
export const useIconChunk = useEBDSIconChunk;

/**
 * @deprecated Please move to direct import from ebds-react/dist/ssr
 * @param props
 * @constructor
 */
export const IconAsChunk = (props) => <EBDSIconAsChunk iconName={props.iconName} />;

export const BoschIconAsChunk = (props) => {
  if (!props.iconName) {
    return null;
  }

  return <BoschIcon icon={props.iconName} srText={`Button ${props.iconName} Icon`} />;
};
